<template>
  <div ref="list" class="users-groups-users-list">
    <template v-if="!gettingUsers">
      <ul v-for="(user, idx) in users" :key="idx" class="table__row" @click="openUserInAside(user)">
        <li class="table__col">
          <p class="table__text">{{ user.name }} {{ user.lastname }}</p>
        </li>
        <li class="table__col">
          <p class="table__text">{{ user.city }}</p>
        </li>
        <li class="table__col">
          <p class="table__text">{{ user.email }}</p>
        </li>
        <li class="table__col">
          <Phone :value="user.phone"></Phone>
        </li>
        <li class="table__col">
          <InlineSocials
            :vk="user.vkLink"
            :fb="user.fbLink"
            :insta="user.instaLink"
          ></InlineSocials>
        </li>
        <li class="table__col">
          <p class="table__text" :class="{ '-empty-niche-': !user.niche }">
            {{ user.niche ? user.niche : 'Без бизнеса' }}
          </p>
        </li>
      </ul>
    </template>
    <ul v-if="gettingUsers || gettingMoreUsers" class="table__row -ajax-">
      <li v-for="(i, index) in 6" :key="index" class="table__col">
        <p class="ajax__line ajax__line-table-text"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash';
import InlineSocials from '@/components/InlineSocials';

export default {
  components: { InlineSocials },
  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    users: [],
    currentPage: 1,
    gettingUsers: true,
    hasMoreUsers: true,
    gettingMoreUsers: false,
    observerOptions: {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    }
  }),
  watch: {
    gettingUsers() {
      this.$nextTick(() => {
        this.observerFunction();
      });
    },
    gettingMoreUsers(val) {
      this.$nextTick(() => {
        if (!val && this.hasMoreUsers) {
          this.observerFunction();
        }
      });
    }
  },
  async mounted() {
    this.observerOptions.root = this.$refs.list;
    await this.getUsers();
  },
  destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    async getUsers() {
      const res = await this.$store.dispatch('usersGroupsUsers/getUsers', {
        groupId: this.group.id
      });
      if (res && res.users) {
        this.users = _.cloneDeep(res.users);
      }

      this.gettingUsers = false;
    },
    async getMoreUsers() {
      if (!this.hasMoreUsers) {
        return;
      }

      this.currentPage++;
      this.gettingMoreUsers = true;
      const res = await this.$store.dispatch('usersGroupsUsers/getMoreUsers', {
        groupId: this.group.id,
        page: this.currentPage
      });
      if (res && res.status === 'success') {
        if (res.users && res.users.length) {
          this.users = [...this.users, ...res.users];
        } else if (res.users) {
          this.hasMoreUsers = false;
        }
      }
      this.gettingMoreUsers = false;
    },
    observerFunction() {
      if (!this.users.length) {
        return;
      }

      this.observer = new IntersectionObserver(this.handleObserver, this.observerOptions);
      this.target = this.$refs.list.querySelector('.table__row:last-child');
      this.observer.observe(this.target);
    },
    handleObserver(entries, observer) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        this.getMoreUsers();
      }
    },
    openUserInAside(user) {
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'isUserOpen',
        value: true
      });
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
      this.$store.dispatch('usersGroups/setAsideData', {
        path: 'user',
        value: user
      });
    }
  }
};
</script>
